import Divider from "@components/common/Divider";
import { JSON_SCHEMAS } from "@components/utils/constants";
import { ILocationResponse } from "@customTypes/modelResponses";
import JsonLdSchema from "@libs/schema/JsonLdSchema";
import { useRef } from 'react'
import DangerouslySetHtml from '@libs/parser/components/DangerouslySetHtml'

interface ILocationPageTopSection {
  data: ILocationResponse;
}

const LocationPageTopSection = ({
                                  data,
                                }: ILocationPageTopSection): JSX.Element => {
  const overviewParentRef = useRef(null);
  return (
    <>
      <JsonLdSchema
        data={{
          breadcrumbObjects: undefined,
          schema: undefined,
          content: data,
        }}
        type={JSON_SCHEMAS.ATTRACTION}
      />
      <div className="relative flex w-full justify-between">
        <div className="mx-5 desktop:mx-0">
          <div className="w-[100%]">
            {/* Removed line-clamp */}
            {/* <p className="text-darkgray desktop:text-p text-p14 line-clamp-5"> */}
            <p className="text-p text-darkgray" ref={overviewParentRef}>
              <DangerouslySetHtml parentRef={overviewParentRef} html={data.Overview}/>
            </p>
          </div>
        </div>
      </div>
      <Divider variant="short"/>
    </>
  );
};

export default LocationPageTopSection;
